

export default class ObjectList<T> 
{
    object_list             : {}        = {};
    plain_list              : any[]     = [];
    is_object_list          : Boolean   = false;
    key_field               : any;

    filtered_list           : any[]     = [];

    constructor(list = null, key_field = null)
    {
        this.setList(list , key_field);
    }

    setList(list = null, key_field = null)
    {
        if (list !== null)
        {
            for (var element of list)
            {
                this._innerPush(element , key_field);
            }
            this.plain_list = list;
        }
    }
    
    cloneList(list = null, key_field = null)
    {
        var cloned_list = Array.from(list);
        if (cloned_list !== null)
        {
            for (var element of cloned_list)
            {
                this._innerPush(element , key_field);
            }
            this.plain_list = cloned_list;
        }
    }

    /**
     * Convert internal Object List to plain array
     */
    _objectListToPlain()
    {
        var list = [];
        //NOTE: Waiting to have .values() in ES7
        for (var key in this.object_list)
        {
            list.push(this.object_list[key]);
        }
        return list;
    }

    /**
     * Return the lenght of current list
     */
    length() : Number
    {
        return this.plain_list.length;
    }

    /**
     * Return list as Plain Array
     */
    all() : T[]
    {
        return this.plain_list;
    }

    /**
     * Return the Object with keys
     */
    getAll() : Object
    {
        return this.object_list;
    }

    /**
     * Return key list of object array
     */
    getKeys()
    {
        return Object.keys(this.object_list);
    }
    
    sort(key = null)
    {
        if (key === null)
        {
            this.plain_list.sort((a, b) => (a[this.key_field] > b[this.key_field]) ? 1 : -1);
        }
        else
        {
            this.plain_list.sort((a, b) => (a[key] > b[key]) ? 1 : -1);
        }
    }

    getKeysAsNumbers() : Number[]
    {
        return Object.keys(this.object_list).map(numStr => parseInt(numStr));
    }

    /**
     * Return a filtered list.
     * @param probe String Search FUll like case insensitive
     * @param key_field If set, it will search in key object value, otherwise it search inside array
     */
    filter(probe , key_field = null)
    {
        if (probe === "" || probe === undefined || probe === null) //if empoty, i will return all the plain_list array
        {
            [].splice.apply(this.filtered_list, [0, this.filtered_list.length].concat(this.plain_list));
        }
        else //otherwise I will check if is an array of object or a plain array
        {
            [].splice.apply(this.filtered_list, [0, this.filtered_list.length].concat([]));
            if (key_field !== null)
            {
                var filtered_array = this.plain_list.filter(x => x[key_field].toLowerCase().includes(probe.toLowerCase()));
            }
            else
            {
                var filtered_array = this.plain_list.filter(x => x.toLowerCase().includes(probe.toLowerCase()));
            }
            [].splice.apply(this.filtered_list, [0, this.filtered_list.length].concat(filtered_array));
        }
        
        return this.filtered_list;
    }

    /**
     * Clear both list without loosing and keep object in memory
     */
    clear()
    {
        [].splice.apply(this.plain_list, [0, this.plain_list.length].concat([]));
        for (var key in this.object_list) 
        {
              delete this.object_list[key];
        }
        this.filtered_list = [];
    }

    /**
     * Merge current list with passed list
     * @param list = plain or object
     * @param key_field  = key value for indexing object list
     */
    merge(list , key_field = null)
    {
        if (list instanceof ObjectList)
        {
            this.is_object_list = true;
            list = list.all();
        }

        if (this.is_object_list || this.key_field !== null)
        {
            this.key_field      = this.key_field === undefined ? key_field : this.key_field;
            for (var single_element of list)
            {
                this.object_list[single_element[this.key_field]] = single_element;
            }
        }
        [].splice.apply(this.plain_list, [this.plain_list.length, 0].concat(list));
    }

    /**
     * get Single element by key
     */
    get(key) :T
    {
        if (this.is_object_list)
        {
            return this.object_list[key];
        }
        else
        {
            return this.plain_list[key];
        }
    }

    getFirst()
    {
        return this.plain_list[0];
    }

    getLast()
    {
        return this.plain_list[ this.plain_list.length - 1];
    }
    
    getAsClone(key) : T
    {
        if (this.is_object_list)
        {
            return Object.assign({} , this.object_list[key])
        }
        else
        {
            return Object.assign({} , this.plain_list[key])
        }
        
    }

    clone()
    {
        let cloned = this.plain_list.map((x) => x);
        return new ObjectList<T>(cloned, this.key_field);
    }

    /**
     * Remove value from array based on object key or array index for plain array
     * @param key 
     */
    remove(key)
    {
        if (!this.is_object_list)
        {
            this.plain_list.splice(key,1);
        }
        else
        {
            delete this.object_list[key];
            this.plain_list.length = 0; 
            [].splice.apply(this.plain_list, [0, this.plain_list.length].concat(this._objectListToPlain()));
        }
    }

    /**
     * Remove all element of passed list from current internal list
     * @param list List of object to remove
     * @param key_field Field of Object used to mark object
     */
    cut(list , key_field = null)
    {
        if (key_field === null) key_field = this.key_field;

        if (list instanceof ObjectList)
        {
            list = list.getAll();
        }
        
        if (this.is_object_list) //removing from object list
        {
            for (var element of list)
            {
                this.remove(element[key_field]);
            }
        }
        else //removing from the plain list
        {
            for (var element of list)
            {
                var key_to_delete = this.plain_list.indexOf(element);
                this.remove(key_to_delete);
            }
        }
        
        
    }

    _innerPush(single_element , key_field = null)
    {
        if (key_field !== null)
        {
            this.key_field      = this.key_field === undefined ? key_field : this.key_field;
            this.is_object_list = true; //if element is added with a key, its an object list
            this.object_list[single_element[key_field]] = single_element;
        }
        else if (this.is_object_list)
        {
            this.object_list[single_element[this.key_field]] = single_element;
        }
    }

    /**
     * Add a single element to internal list
     * If key_field is set, an object array will be created
     */
    push(single_element : T, key_field = null)
    {
        this._innerPush(single_element , key_field);
        this.plain_list.push(single_element);
    }

    /**
     * Alias of Push
     */
    add (element : T , key_field = null)
    {
        this.push(element, key_field);
    }

    /**
     * Treansfer all data on destionation array without loosing destination reference
     */
    pour(destination)
    {
        [].splice.apply(destination, [0, destination.length].concat(this.plain_list));
    }

    copyInto(destination)
    {
        this.pour(destination);
    }


    setProperty(key , property , value)
    {
        this.object_list[key][property] = value;
    }

    setPropertyForAll(property , value)
    {
        for (var element of this.plain_list)
        {
            element[property] = value;
        }
    }

    isIn(key_value)
    {
        return this.object_list[key_value] !== undefined;
    }

    isInByFunction(compare_func : Function)
    {
        for (var el of this.plain_list)
        {
            if (compare_func(el))
            {
                return true
            }
        }
        return false
    }

    valueList(value_key) : any[]
    {
        var values = [];
        for (let kk in this.plain_list)
        {
            values.push(this.plain_list[kk][value_key]);
        }
        return values;
    }
}
